import React, { useEffect } from "react";
import { Box, Typography, IconButton, Divider, Chip, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import dayjs from "dayjs";
import DocumentItem from "../../Components/Masters/DocumentItem";
import { useUser } from "../../context/AuthContext";

function ViewDetails({ isViewOpen, setIsViewOpen, selectedData, setView,  handleEdit, activeTab}) {
  const {user} = useUser();
  useEffect(() => {
    console.log("Selected Data in View:", selectedData);
  }, [selectedData]);

  const formatDateBasedOnType = (dateStr, dataType) => {
    if (!dateStr || !dataType) return "-";

    if (dataType === "Production") {
      const [monthStr, yearStr] = dateStr.split("-");
      const month = parseInt(monthStr, 10);
      return dayjs(`${yearStr}-${month}-01`).format("MMMM-YY"); // e.g., April-25
    }

    if (dataType === "Revenue") {
      return `FY ${dateStr}`; // e.g., FY 2023-24
    }

    return dateStr;
  };

  const handleEditClick = () => {
    setIsViewOpen(false); // Close the view drawer
    handleEdit(selectedData); // Pass the current data to edit handler
  };


  const renderField = (label, value) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
        {label}
      </Typography>
      <Typography variant="body1">{value || "-"}</Typography>
    </Box>
  );


  console.log("Facility Name", selectedData.facilityName?.facilityName, selectedData);

  const renderSection = () => {
    if (!selectedData) return null;

    const isProduction = selectedData.dataType === "Production";

    return (
      <>
        {/* {renderField("Data Entered", selectedData.dataType)}
        {renderField("Data Period Type", selectedData.periodType)} */}

        {renderField(
          "Date of Entry",
          new Date(selectedData.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        )}

        {/* Show Type and Facility for Production when user is company admin */}
        {user?.companyAdmin && isProduction && (
          <>
            {renderField("Type", selectedData.type)}
            {selectedData.type === "Facility" && 
              renderField("Facility Name", selectedData.facilityName?.facilityName)}
          </>
        )}

        

        {renderField(
          isProduction ? "Month of Production" : "Financial Year",
          formatDateBasedOnType(selectedData.date, selectedData.dataType)
        )}

        {isProduction ? (
          <>
            {renderField(
              "Production Quantity",
              selectedData.production?.quantity
            )}
            {renderField("Production Unit", selectedData.production?.unit)}
          </>
        ) : (
          <>
            {renderField("Revenue Value", selectedData.revenue?.value)}
            {renderField("Currency", selectedData.revenue?.currency)}
          </>
        )}

        {renderField("Remarks", selectedData.remarks)}
      </>
    );
  };

  return (
    <Drawer
      anchor="right"
      open={isViewOpen}
      onClose={() => setIsViewOpen(false)}
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          overflowY: "auto",
        },
      }}
    >
      <Box display="flex" gap={3} sx={{ width: "450px" }}>
        {/* Close Icon in a circle */}
        <Box
          sx={{
            backgroundColor: "#fff",
            height: "20px",
            padding: "13px",
            margin: "30px 0 0 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "80%",
            width: "5%",
          }}
        >
          <IconButton
            onClick={() => setIsViewOpen(false)}
            sx={{ color: "black" }}
          >
            <CloseIcon sx={{ fontSize: "1.2rem" }} />
          </IconButton>
        </Box>

        {/* Drawer content */}
        <Box
          sx={{
            width: "100%",
            p: 3,
            backgroundColor: "#fff",
            minHeight: "100vh",
          }}
        >
          {/* Header */}
          <Typography
            variant="h6"
            sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
          >
            {selectedData?.dataType === "Production"
              ? "Production Report"
              : "Revenue Report"}
          </Typography>

          {/* Render fields */}
          {renderSection()}

          {/* Documents section */}
          {selectedData?.documents?.length > 0 && (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Documents
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={1}>
                {selectedData.documents.map((url, index) => (
                  <DocumentItem key={`doc-${index}`} url={url} />
                ))}
              </Box>
            </>
          )}

<Button
                  variant="contained"
                  sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
                  onClick={handleEditClick}
                >
                  Edit
                </Button>
        </Box>
        
      </Box>
    </Drawer>
  );
}

export default ViewDetails;
